import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { BootGate } from './components/layout/boot-gate';
import { ErrorBoundary } from './components/layout/error-boundary';
import { createStaticAuthPort, setAuthPort } from './data/auth';
import { config } from './data/config';
import { colaboradorDoDemo } from './data/sources/mock/visibilidade';
import './index.css';

/**
 * Composition root — mesmo desenho do PAN. Dois caminhos, decididos por
 * `VITE_DATA_SOURCE`:
 *
 *  - `rest` (padrão): `BootGate` autentica no Keycloak (client
 *    `compilacoes-app`) e só então monta a aplicação.
 *  - `demo`: porta de autenticação estática, com as capabilities de
 *    `VITE_DEMO_CAPABILITIES`, e dados de exemplo em memória.
 */

if (config.dataSource === 'demo') {
  setAuthPort(
    createStaticAuthPort(
      '',
      { nome: 'Sessão de demonstração', detalhe: 'Dados de exemplo' },
      // Como na API: conta de fora (VITE_DEMO_COLABORADOR=false) não tem capability nenhuma.
      colaboradorDoDemo() ? config.demoCapabilities : [],
    ),
  );
}

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root não encontrado no index.html.');

const aplicacao = (
  <BrowserRouter basename={config.basePath} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <App />
  </BrowserRouter>
);

createRoot(raiz).render(
  <StrictMode>
    <ErrorBoundary>
      {config.dataSource === 'demo' ? aplicacao : <BootGate>{aplicacao}</BootGate>}
    </ErrorBoundary>
  </StrictMode>,
);
